const PARTIAL_WORK_OBJECT_STATUS = {
  ACCEPTED: 'accepted',
  SUBMITTED: 'submitted',
};

export default PARTIAL_WORK_OBJECT_STATUS;
